import React from 'react';
import { SvgIcon } from 'material-ui';

const SwitchIcon = props => (
  <SvgIcon {...props} viewBox='0 0 44 44'>
    <g fill='none' fillRule='evenodd'>
      <circle cx='22' cy='22' r='22' fill='#FFF' />
      <path stroke='#4D7CFF' strokeWidth='2' d='M31 26H16l6.484 4M14 19h15l-6.484-4' />
    </g>
  </SvgIcon>
);

export default SwitchIcon;



// WEBPACK FOOTER //
// ./src/icons/SwitchIcon.js